import { createSvgIcon } from "@mui/material";

const ReportingIcon = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 8.12698C0 3.63857 3.8205 0 8.53333 0H23.4667C28.1795 0 32 3.63858 32 8.12699V23.873C32 28.3614 28.1795 32 23.4667 32H8.53333C3.8205 32 0 28.3614 0 23.873V8.12698Z"
      fill="#F6F8FA"
    />
    <path
      d="M8.61206 8.98648C8.61206 7.80828 9.56719 6.85315 10.7454 6.85315H23.9699C25.1481 6.85315 26.1032 7.80828 26.1032 8.98648V19.8352C26.1032 21.0134 25.1481 21.9686 23.9699 21.9686H10.7454C9.56719 21.9686 8.61206 21.0134 8.61206 19.8352V8.98648Z"
      fill="#DADEFC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4643 12.7219C11.8079 12.7219 12.0865 13.0004 12.0865 13.3441V19.2057C12.0865 19.5493 11.8079 19.8279 11.4643 19.8279C11.1206 19.8279 10.842 19.5493 10.842 19.2057V13.3441C10.842 13.0004 11.1206 12.7219 11.4643 12.7219Z"
      fill="#4453C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3134 14.5642C15.657 14.5642 15.9356 14.8428 15.9356 15.1864L15.9356 19.2057C15.9356 19.5493 15.657 19.8279 15.3134 19.8279C14.9697 19.8279 14.6912 19.5493 14.6912 19.2057L14.6912 15.1864C14.6912 14.8428 14.9697 14.5642 15.3134 14.5642Z"
      fill="#4453C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1627 11.5903C19.5064 11.5903 19.785 11.8688 19.785 12.2125L19.785 19.2058C19.785 19.5495 19.5064 19.8281 19.1627 19.8281C18.8191 19.8281 18.5405 19.5495 18.5405 19.2058L18.5405 12.2125C18.5405 11.8688 18.8191 11.5903 19.1627 11.5903Z"
      fill="#4453C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.0121 9.0498C23.3558 9.0498 23.6343 9.32838 23.6343 9.67203L23.6343 19.2058C23.6343 19.5494 23.3558 19.828 23.0121 19.828C22.6685 19.828 22.3899 19.5494 22.3899 19.2058L22.3899 9.67203C22.3899 9.32838 22.6685 9.0498 23.0121 9.0498Z"
      fill="#4453C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.6752 7.25085C7.01884 7.25085 7.29742 7.52943 7.29742 7.87308V21.716C7.29742 22.5505 7.97397 23.2271 8.80853 23.2271H25.3247C25.6683 23.2271 25.9469 23.5056 25.9469 23.8493C25.9469 24.1929 25.6683 24.4715 25.3247 24.4715H8.80853C7.28668 24.4715 6.05298 23.2378 6.05298 21.716V7.87308C6.05298 7.52943 6.33156 7.25085 6.6752 7.25085Z"
      fill="#4453C6"
    />
  </svg>,
  "ReportingIcon"
);

export default ReportingIcon;
